import API, { handleRequest } from '@/api/lib/api'

export const getDepositSettings = async restaurant_id =>
  handleRequest(() =>
    API.get(`restaurant/${restaurant_id}/reservation-deposit-settings`)
  )

export const updateDepositSettings = async (id, data) =>
  handleRequest(() => API.put(`restaurant/reservation-deposit-rules/${id}`, data))

export const createDepositSettings = async data =>
  handleRequest(() => API.post(`restaurant/reservation-deposit-rules`, data))

export const deleteDepositSettings = async id =>
  handleRequest(() => API.delete(`restaurant/reservation-deposit-rules/${id}`))

export const getDepositSettingsById = async id =>
  handleRequest(() => API.get(`restaurant/reservation-deposit-rules/${id}`))

export const toggleDepositStatus = async (id, data) =>
  handleRequest(() =>
    API.put(`restaurant/${id}/reservation-deposit-settings/toggle-status`, data)
  )
